import Accesos from '@svgs/accesos.svg';
import Avisos from '@svgs/avisos.svg';
import Billetes from '@svgs/billetes.svg';
import Comunicados from '@svgs/comunicados.svg';
import Cuotas from '@svgs/cuotas.svg';
import CuotasGreen from '@svgs/cuotas-green.svg';
import IconFile from '@svgs/icon-file.svg';
import IconImage from '@svgs/icon-image.svg';
import IconPrint from '@svgs/icon-print.svg';
import IconXml from '@svgs/icon-xml.svg';
import Invitados from '@svgs/invitados.svg';
import Logo from '@svgs/logo.svg';
import Mensajes from '@svgs/mensajes.svg';
import Notificaciones from '@svgs/notificaciones.svg';
import PaseInvitado from '@svgs/pase-invitado.svg';
import PdfIcon from '@svgs/pdf-icon.svg';
import Reglamento from '@svgs/reglamento.svg';
import Reportes from '@svgs/reportes.svg';
import Residentes from '@svgs/residentes.svg';
import Tags from '@svgs/tags.svg';
import Timeback from '@svgs/timeback.svg';
import Vehiculos from '@svgs/vehiculos.svg';
import Viviendas from '@svgs/viviendas.svg';
import ViviendasRed from '@svgs/viviendas-red.svg';
import GpPaqueteria from '@svgs/guest-passes/paqueteria.svg';
import GpPersonal from '@svgs/guest-passes/personal.svg';
import GpProveedor from '@svgs/guest-passes/proveedor.svg';
import GpReunion from '@svgs/guest-passes/reunion.svg';

import Autorizacion from '@svgs/autorizacion.svg';

export const ILLUSTRATIONS = {
  accesos:        { default: Accesos },
  avisos:         { default: Avisos },
  billetes:       { default: Billetes },
  comunicados:    { default: Comunicados },
  cuotas:         { default: Cuotas, green: CuotasGreen },
  iconFile:       { default: IconFile },
  iconImage:      { default: IconImage },
  iconPrint:      { default: IconPrint },
  iconXml:        { default: IconXml },
  invitados:      { default: Invitados },
  logo:           { default: Logo },
  mensajes:       { default: Mensajes },
  notificaciones: { default: Notificaciones },
  paseInvitado:   { default: PaseInvitado },
  pdfIcon:        { default: PdfIcon },
  reglamento:     { default: Reglamento },
  reportes:       { default: Reportes },
  residentes:     { default: Residentes },
  tags:           { default: Tags },
  timeback:       { default: Timeback },
  vehiculos:      { default: Vehiculos },
  viviendas:      { default: Viviendas, red: ViviendasRed },
  gpPaqueteria:   { default: GpPaqueteria },
  gpPersonal:     { default: GpPersonal },
  gpProveedor:    { default: GpProveedor },
  gpReunion:      { default: GpReunion },
  autorizacion:   { default: Autorizacion },
};

export type IllustrationName = keyof typeof ILLUSTRATIONS;
export type IllustrationVariant<N extends IllustrationName> = keyof (typeof ILLUSTRATIONS)[N];
